const keyFor = (userId) => `lounge_last_read_${userId}`;

export const loadLocalReadCursor = async (userId) => {
  if (!userId) return null;
  try {
    return localStorage.getItem(keyFor(userId));
  } catch {
    return null;
  }
};

export const saveLocalReadCursor = async (userId, messageId) => {
  if (!userId || !messageId) return;
  try {
    localStorage.setItem(keyFor(userId), String(messageId));
  } catch {
    /* ignore */
  }
};
